<div #scrollContainer class="message-history-container">
  <div *ngIf="getMessageDates().length; else noMessages">
    <ng-container *ngFor="let date of getMessageDates()">
      <div class="message-date-container">
        <div class="message-date">{{ formatDate(date) }}</div>
      </div>
      <ng-container *ngFor="let message of getMessagesForDate(date)">
        <div
          *ngIf="isInboundMessage(message)"
          class="message-container-in"
          [attr.data-item-id]="message.sid"
        >
          <div class="avatar-patient">
            <span *ngIf="chatState.recipient()?.name as name">
              {{ getNameInitials(name) }}
            </span>
          </div>
          <div class="message-content-wrapper-in">
            <div class="message-in">
              {{ message.content }}
              <app-media-preview
                *ngIf="message.media?.length"
                [media]="message.media || []"
                (mediaLoaded)="onMediaLoaded()"
                size="medium"
                [showFilename]="true"
                [showFilesize]="true"
                [showCloseButton]="false"
              >
              </app-media-preview>
            </div>
            <span class="message-time message-time-in">{{
              message.receivedTimestamp ? formatTime(message.receivedTimestamp) : ''
            }}</span>
          </div>
        </div>
        <div
          *ngIf="!isInboundMessage(message)"
          class="message-container-out"
          [attr.data-item-id]="message.sid"
        >
          <div class="message-content-wrapper-out">
            <div class="message-out">
              {{ message.content }}
              <app-media-preview
                *ngIf="message.media?.length"
                [media]="message.media || []"
                size="medium"
                [showFilename]="true"
                [showFilesize]="true"
                [showCloseButton]="false"
              >
              </app-media-preview>
            </div>
            <div class="message-meta">
              <span
                class="message-status"
                [ngClass]="{
                  'status-sending': message.status === 'sending',
                  'status-sent': message.status === 'sent',
                  'status-delivered': message.status === 'delivered',
                  'status-failed': message.status === 'failed',
                }"
              >
                <ng-container [ngSwitch]="message.status">
                  <mat-icon *ngSwitchCase="'sending'" fontSet="material-icons-outlined"
                    >schedule</mat-icon
                  >
                  <mat-icon *ngSwitchCase="'sent'" fontSet="material-icons-outlined"
                    >check</mat-icon
                  >
                  <mat-icon *ngSwitchCase="'delivered'" fontSet="material-icons-outlined"
                    >check</mat-icon
                  >
                  <mat-icon *ngSwitchCase="'failed'" fontSet="material-icons-outlined"
                    >error</mat-icon
                  >
                </ng-container>
              </span>
              <span class="message-time message-time-out">{{
                message.sentTimestamp ? formatTime(message.sentTimestamp) : ''
              }}</span>
            </div>
          </div>
          <div class="avatar-coach">
            <ng-container
              *ngIf="message.sender.name && message.sender.name.trim(); else defaultAvatar"
            >
              {{ getNameInitials(message.sender.name) }}
            </ng-container>
            <ng-template #defaultAvatar>
              <img src="assets/icons/bardavon.png" alt="Avatar" class="avatar-icon" />
            </ng-template>
          </div>
        </div>
      </ng-container>
    </ng-container>
  </div>
</div>
<ng-template #noMessages>
  <span>No messages.</span>
</ng-template>
